export enum ChangeSource {
  SOURCE_EMAIL = 'email',
  SOURCE_PHONE = 'phone',
  SOURCE_MEETING = 'meeting',
  SOURCE_PROTOCOL = 'protocol'
}
